import { Dialog, DialogFooter, DialogType, ITheme, PrimaryButton } from "@fluentui/react";
import moment from "moment";
import React, { useContext, useState } from "react";
import { queryPlannerItemsAsync } from "src/api/plannerApi";
import { localize } from "src/l10n";
import ThemeContext from "src/style/ThemeContext";
import { SpintrTypes } from "src/typings";
import { Editor } from "tinymce";
import { FormTokenizedObjectInput } from "../../Forms";
import ITokenizedInputItem from "../../Forms/ITokenizedInputItem";
import PopupHeader from "../../PopupHeader";

interface IProps {
    editor: Editor;
    onClose: () => void;
}

const TinyPlannerItemFunction: React.FC<IProps> = ({ editor, onClose }) => {
    const theme = useContext(ThemeContext) as ITheme;
    const [selectedItem, setSelectedItem] = useState<ITokenizedInputItem | null>(null);

    const autocomplete = (text: string): Promise<ITokenizedInputItem[]> => {
        return queryPlannerItemsAsync({
            skip: 0,
            take: 5,
            orderByColumn: "startsAt",
            orderAscending: false,
            status: SpintrTypes.ContentStatus.Published,
            search: text || undefined,
        }).then((response) =>
            response.items.map((item) => {
                const start = moment(item.startsAt).format("YYYY-MM-DD");
                const end = moment(item.endsAt).format("YYYY-MM-DD");

                return {
                    key: item.id,
                    name: item.name,
                    subText: `${start} - ${end}`,
                };
            }),
        );
    };

    const escapeHtml = (str: string): string => {
        const div = document.createElement("div");
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    };

    const plannerItemSelected = () => {
        if (!selectedItem) {
            return;
        }

        const id = Number(selectedItem.key);

        if (isNaN(id)) {
            return;
        }

        const name = escapeHtml(selectedItem.subText ?? selectedItem.name);
        const html = `<div><span class="redactorPlannerItem planner-${id}">${name}</span></div> <br />`;

        editor.insertContent(html);
        onClose();
    };

    return (
        <Dialog
            hidden={false}
            containerClassName="dialogWithPopupHeader"
            onDismiss={onClose}
            modalProps={{
                isBlocking: true,
                allowTouchBodyScroll: true,
            }}
            dialogContentProps={{
                type: DialogType.normal,
                title: localize("PLANNER_OBJECT"),
                showCloseButton: true,
                closeButtonAriaLabel: localize("Stang"),
            }}
        >
            <PopupHeader
                text={localize("PLANNER_OBJECT")}
                onClose={onClose}
            />
            <FormTokenizedObjectInput
                label={localize("PLANNER_OBJECT")}
                items={selectedItem ? [selectedItem] : []}
                itemLimit={1}
                autocomplete={autocomplete}
                onChange={(items) => {
                    setSelectedItem(items.length > 0 ? items[0] : null);
                }}
            />
            <DialogFooter>
                <PrimaryButton
                    theme={theme}
                    disabled={!selectedItem}
                    onClick={plannerItemSelected}
                    text={localize("Valj")}
                />
            </DialogFooter>
        </Dialog>
    );
};

export default TinyPlannerItemFunction;
